import React, { useEffect } from 'react';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ClientLogos from './components/ClientLogos';
import MissionStatement from './components/MissionStatement';
import Services from './components/Services';
import Pricing from './components/Pricing';
import ROICalculator from './components/ROICalculator';
import Process from './components/Process';
import Team from './components/Team';
import CaseStudies from './components/CaseStudies';
import BeforeAfter from './components/BeforeAfter';
import TechStackPartners from './components/TechStackPartners';
import Resources from './components/Resources';
import ServiceComparison from './components/ServiceComparison';
import TestimonialCarousel from './components/TestimonialCarousel';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LiveChat from './components/LiveChat';

function App() {
  // Cursor Logic
  useEffect(() => {
    const cursor = document.createElement('div');
    const cursorGlow = document.createElement('div');
    
    // Inline styles for cursor
    Object.assign(cursor.style, {
      position: 'fixed', width: '20px', height: '20px', borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(65, 105, 225, 0.6) 0%, transparent 70%)',
      pointerEvents: 'none', zIndex: '9999', mixBlendMode: 'screen', 
      transform: 'translate3d(-100px, -100px, 0)', transition: 'transform 0.1s ease-out'
    });

    Object.assign(cursorGlow.style, {
      position: 'fixed', width: '200px', height: '200px', borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(65, 105, 225, 0.15) 0%, transparent 70%)',
      pointerEvents: 'none', zIndex: '9998', filter: 'blur(40px)',
      transform: 'translate3d(-200px, -200px, 0)', transition: 'transform 0.2s ease-out'
    });

    document.body.appendChild(cursor);
    document.body.appendChild(cursorGlow);

    const onMouseMove = (e) => {
      cursor.style.transform = `translate3d(${e.clientX - 10}px, ${e.clientY - 10}px, 0)`;
      cursorGlow.style.transform = `translate3d(${e.clientX - 100}px, ${e.clientY - 100}px, 0)`;
    };

    window.addEventListener('mousemove', onMouseMove);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      if(document.body.contains(cursor)) document.body.removeChild(cursor);
      if(document.body.contains(cursorGlow)) document.body.removeChild(cursorGlow);
    };
  }, []);

  // Intersection Observer for Fade-in Animation
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.animation = 'fadeInUp 0.8s ease forwards';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    // Wait a bit for DOM to be ready
    setTimeout(() => {
        document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));
    }, 100);
  }, []);

  // Parallax effect on scroll
  useEffect(() => {
    const handleParallax = () => {
      const scrolled = window.pageYOffset;
      const parallaxElements = document.querySelectorAll('.hero-visual, .code-editor-glass');
      parallaxElements.forEach(el => {
        const speed = 0.5;
        el.style.transform = `translateY(${scrolled * speed}px)`;
      });
    };

    window.addEventListener('scroll', handleParallax);
    return () => window.removeEventListener('scroll', handleParallax);
  }, []);

  // Add magnetic effect to buttons
  useEffect(() => {
    const buttons = document.querySelectorAll('.glass-btn');
    
    buttons.forEach(button => {
      button.addEventListener('mousemove', (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        button.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
      });
      
      button.addEventListener('mouseleave', () => {
        button.style.transform = 'translate(0, 0)';
      });
    });
  }, []);

  return (
    <div className="App">
      <div className="background-container">
        <div className="gradient-bg"></div>
        <div className="wave-pattern"></div>
        {/* Particles */}
        <div className="particles">
           {[...Array(50)].map((_, i) => (
             <div key={i} className="particle" style={{
               width: Math.random() * 4 + 2 + 'px',
               height: Math.random() * 4 + 2 + 'px',
               left: Math.random() * 100 + '%',
               animationDelay: Math.random() * 15 + 's',
               animationDuration: (15 + Math.random() * 10) + 's'
             }}></div>
           ))}
        </div>
      </div>

      <LiveChat />
      <Navbar />
      <Hero />
      <ClientLogos />
      <MissionStatement />
      <Services />
      <Pricing />
      <ROICalculator />
      <Process />
      <Team />
      <CaseStudies />
      <BeforeAfter />
      <TechStackPartners />
      <Resources />
      <ServiceComparison />
      <TestimonialCarousel />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;